import { useRouteLoaderData } from '@remix-run/react';

export interface ChannelConfig {
  locales: string[];
  defaultLocale: string;
  defaultCurrency: string;
  defaultChannel: string;
  currencies: { channel: string; currency: string }[];
  /** Whether registration requires e-mail verification (double opt-in) before login. */
  accountVerificationRequired: boolean;
}

export function useChannelConfig(): ChannelConfig {
  const data = useRouteLoaderData('root') as { channelConfig: ChannelConfig };
  return data.channelConfig;
}

export function useAccountVerificationRequired(): boolean {
  const config = useChannelConfig();
  return config.accountVerificationRequired;
}

export function useDefaultCurrency(): string {
  const config = useChannelConfig();
  return config.defaultCurrency;
}

export function useDefaultChannel(): string {
  const config = useChannelConfig();
  return config.defaultChannel;
}
